export * from './form-scale.model';
export * from './form-scale-edit/form-scale-edit.component';
export * from './form-scale-stat/form-scale-stat.component';
export * from './form-scale-view/form-scale-view.component';
